var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1214018 20.4887781l-4.2953693-4.2793018c.7809763-1.5561097 1.3016271-3.3715711 1.3016271-5.1870324C22.1276596 4.9276808 17.1814768 0 11.0638298 0 4.94618273 0 0 4.9276808 0 11.0224439c0 6.0947631 4.94618273 11.0224439 11.0638298 11.0224439 1.8222778 0 3.6445557-.5187033 5.2065081-1.2967581l4.2953692 4.2793017c1.3016271 1.2967581 3.2540676 1.2967581 4.5556947 0 1.1714643-1.2967581 1.1714643-3.2418952 0-4.5386533zm-14.0564957-2.0352619c-4.13052774 0-7.45789734-3.3149231-7.45789734-7.43 0-4.11507691 3.3273696-7.42999999 7.45789734-7.42999999 4.1305278 0 7.4578974 3.31492308 7.4578974 7.42999999 0 4.1150769-3.3273696 7.43-7.4578974 7.43z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3096a00f7ceb6ea7c859b4619d213b8d.svg";
export { ForwardRef as ReactComponent };